export default __webpack_public_path__ + "static/media/Magnum.4a89c58b.jpeg";